import { getAttrValue } from '~/src/utils/getAttrValue';

export const getDeathProbability = (person: Person): number => {
  return getAttrValue(person, 'death_probability');
};
